enum OcurrenceClassification {
    //Correção, Prevenção ou Melhoria
    Correction = 1,
    Prevention = 2,
    Improvement = 3
}

export default OcurrenceClassification;